


Vue.config.productionTip = false



import './app-imports.js'

import Vue from 'vue'
import vmApp from './app.vue'



new Vue(vmApp).$mount('.app')



// WEBPACK FOOTER //
// ./src/app.js